import OwnerController from "../owner_controller";
import { OWNER_REPORT_SOLD_OUT_BY_DATE, GROUP_REPORT_SOLD_OUT_BY_DATE } from '../../routes';

export default class extends OwnerController {
  static values = { date: String, type: String }
  initialize() {
    this.fetch();
  }

  async fetch() {
    this.setEmpty(this);
    this.setLoading(this);
    const { data } = await this.axios.get(this.soldOutUrl, {
      params: { date: this.dateValue, time_type: this.typeValue, restaurant_id: this.filter.restaurantId }
    });
    this.processPartial(data);
  }

  get soldOutUrl() {
    if(this.filter.restaurantGroupId == null)
      return OWNER_REPORT_SOLD_OUT_BY_DATE;
    return GROUP_REPORT_SOLD_OUT_BY_DATE;
  }
}
